import gql from 'not-graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import {
  ValidatePremiseRequest,
  ValidatePremiseResponse,
} from '../__generated__/pge-types';

const VALIDATE_PREMISE_QUERY = gql`
  query ValidatePremise($payload: ValidatePremiseRequest) {
    validatePremise(payload: $payload) {
      premId
      spList {
        spId
        isEligible
        meterStatusInactive
        pendingDisconnect
        spTypeNotResidential
      }
      eligibility
    }
  }
`;

export const useValidatePremiseQuery = () => {
  const { refetch, loading, error, data } = useQuery<
    { validatePremise: ValidatePremiseResponse[] },
    { payload: ValidatePremiseRequest }
  >(VALIDATE_PREMISE_QUERY, {
    skip: true,
  });
  return {
    refetch,
    loading,
    error,
    data,
  };
};

export default useValidatePremiseQuery;
